import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RotateCcw, Save } from "lucide-react";
import { Input } from "@/components/ui/input";
import { RichEditor } from "@/components/RichEditor";
import { api, fmtDate, formatErr } from "@/lib/api";
import { cn } from "@/lib/utils";

export const EmailTemplates = () => {
  const [list, setList] = useState([]);
  const [sel, setSel] = useState(null);
  const [form, setForm] = useState({ subject: "", body: "" });
  const [ver, setVer] = useState(0);

  const pick = (t) => {
    setSel(t);
    setForm({ subject: t.subject, body: t.body });
    setVer((v) => v + 1);
  };
  useEffect(() => {
    api.get("/admin/email-templates").then((r) => { setList(r.data); pick(r.data[0]); }).catch((e) => toast.error(formatErr(e)));
  }, []);

  const replace = (t) => {
    setList((l) => l.map((x) => (x.key === t.key ? t : x)));
    pick(t);
  };
  const save = async () => {
    try {
      const { data } = await api.put(`/admin/email-templates/${sel.key}`, form);
      replace(data);
      toast.success("Template saved");
    } catch (e) {
      toast.error(formatErr(e));
    }
  };
  const reset = async () => {
    const { data } = await api.delete(`/admin/email-templates/${sel.key}`);
    replace(data);
    toast.success("Template reset to default");
  };

  if (!sel) return null;
  return (
    <div className="grid gap-6 lg:grid-cols-[240px_1fr]" data-testid="email-templates">
      <div className="space-y-1">
        {list.map((t) => (
          <button key={t.key} onClick={() => pick(t)} data-testid={`template-tab-${t.key}`}
            className={cn("w-full text-left rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors", sel.key === t.key ? "bg-primary text-primary-foreground" : "hover:bg-secondary")}>
            {t.label}{t.customized && <span className="ml-1 text-xs opacity-75">· edited</span>}
          </button>
        ))}
      </div>
      <div className="space-y-4 rounded-2xl border border-border bg-card p-5">
        <div>
          <p className="text-sm font-bold mb-2">Subject</p>
          <Input value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="h-11 rounded-xl" data-testid="template-subject-input" />
        </div>
        <div>
          <p className="text-sm font-bold mb-2">Body</p>
          <RichEditor key={`${sel.key}-${ver}`} value={form.body} onChange={(body) => setForm((f) => ({ ...f, body }))} tags={sel.tags} testId="template-editor" minHeight={260} />
          <p className="text-xs text-muted-foreground mt-2">Tags like {"{first_name}"} are replaced for each recipient. Links tags become clickable.</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <button onClick={save} className="inline-flex h-10 items-center gap-2 px-5 rounded-full bg-primary text-primary-foreground font-bold text-sm" data-testid="template-save-button"><Save className="h-4 w-4" />Save template</button>
          {sel.customized && <button onClick={reset} className="inline-flex h-10 items-center gap-2 px-4 rounded-full border border-border font-semibold text-sm hover:bg-secondary" data-testid="template-reset-button"><RotateCcw className="h-4 w-4" />Reset to default</button>}
          {sel.updated_at && <span className="text-xs text-muted-foreground">Last edited {fmtDate(sel.updated_at)}</span>}
        </div>
      </div>
    </div>
  );
};
